import React from 'react';
import styled from 'styled-components';

const FooterStyles = styled.footer`
  height: 100px;
  border-top: 1px solid var(--gray);
  margin-top: 300px;
  margin-bottom: auto;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export default function Footer() {
  return (
    <FooterStyles>
      <span>&#169; Clay Carlson</span>
    </FooterStyles>
  );
}
